import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = {
  key: 0,
  class: "col-9"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  class: "col"
}
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CssDimensionEditor = _resolveComponent("CssDimensionEditor")!
  const _component_AdvancedColorEditor = _resolveComponent("AdvancedColorEditor")!
  const _component_MetadataGroupCard = _resolveComponent("MetadataGroupCard")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createVNode(_component_MetadataGroupCard, {
        title: _ctx.$t('cms.eyebrow'),
        enabled: _ctx.enabled,
        name: _ctx.$t('cms.eyebrow'),
        errors: _ctx.errors,
        "onUpdate:enabled": _ctx.onEnabledChanged,
        onReset: _ctx.resetToPersisted
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.localDto.style_code,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDto.style_code) = $event)),
                    _ctx.onStyleChanged
                  ],
                  options: _ctx.enumStyleCode,
                  name: _ctx.$t('cms.eyebrowStyle'),
                  label: _ctx.$t('cms.eyebrowStyle'),
                  selectText: _ctx.$t('selectText'),
                  rules: "required",
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
              ]),
              (_ctx.showText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.localDto.text,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.text) = $event)),
                        _ctx.emitModelChanged
                      ],
                      name: _ctx.$t('cms.eyebrowText'),
                      label: _ctx.$t('cms.eyebrowText'),
                      rules: 'required|max:150',
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "name", "label", "errors", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.localDto.font_weight_code,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.font_weight_code) = $event)),
                    _ctx.emitModelChanged
                  ],
                  options: _ctx.enumFontWeightCode,
                  name: _ctx.$t('cms.eyebrowFontWeight'),
                  label: _ctx.$t('cms.eyebrowFontWeight'),
                  selectText: _ctx.$t('selectText'),
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
              ]),
              (_ctx.showLetterSpacing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_CssDimensionEditor, {
                      modelValue: _ctx.localDto.letter_spacing,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localDto.letter_spacing) = $event)),
                        _ctx.emitModelChanged
                      ],
                      name: _ctx.$t('cms.eyebrowLetterSpacing'),
                      label: _ctx.$t('cms.eyebrowLetterSpacing'),
                      errors: _ctx.errors,
                      allowDisable: false,
                      allowEmptyValue: true,
                      placeholder: _ctx.$t('default')
                    }, null, 8, ["modelValue", "name", "label", "errors", "placeholder", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.localDto.text_transform_code,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDto.text_transform_code) = $event)),
                    _ctx.emitModelChanged
                  ],
                  options: _ctx.enumTextTransformationCode,
                  name: _ctx.$t('cms.eyebrowTextTransform'),
                  label: _ctx.$t('cms.eyebrowTextTransform'),
                  selectText: _ctx.$t('selectText'),
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.localDto.margin_bottom_code,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localDto.margin_bottom_code) = $event)),
                    _ctx.emitModelChanged
                  ],
                  options: _ctx.enumMarginCode,
                  name: _ctx.$t('cms.eyebrowMarginBottom'),
                  label: _ctx.$t('cms.eyebrowMarginBottom'),
                  selectText: _ctx.$t('selectText'),
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
              ])
            ]),
            (_ctx.showBarWidth)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.localDto.bar_width_code,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localDto.bar_width_code) = $event)),
                        _ctx.emitModelChanged
                      ],
                      options: _ctx.enumBarWidthCode,
                      name: _ctx.$t('cms.eyebrowBarWidth'),
                      label: _ctx.$t('cms.eyebrowBarWidth'),
                      selectText: _ctx.$t('selectText'),
                      errors: _ctx.errors
                    }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_CssDimensionEditor, {
                      modelValue: _ctx.localDto.bar_thickness,
                      "onUpdate:modelValue": [
                        _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localDto.bar_thickness) = $event)),
                        _ctx.emitModelChanged
                      ],
                      name: _ctx.$t('cms.eyebrowBarThickness'),
                      label: _ctx.$t('cms.eyebrowBarThickness'),
                      errors: _ctx.errors,
                      allowDisable: false,
                      allowEmptyValue: true,
                      placeholder: _ctx.$t('default')
                    }, null, 8, ["modelValue", "name", "label", "errors", "placeholder", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showColor)
              ? (_openBlock(), _createBlock(_component_AdvancedColorEditor, {
                  key: 1,
                  modelValue: _ctx.localDto.color,
                  "onUpdate:modelValue": [
                    _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localDto.color) = $event)),
                    _ctx.emitModelChanged
                  ],
                  name: _ctx.$t('cms.eyebrowColor'),
                  label: _ctx.$t('cms.eyebrowColor'),
                  errors: _ctx.errors,
                  isBackground: true,
                  class: "mb-3"
                }, null, 8, ["modelValue", "name", "label", "errors", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.showTextColor)
              ? (_openBlock(), _createBlock(_component_AdvancedColorEditor, {
                  key: 2,
                  modelValue: _ctx.localDto.text_color,
                  "onUpdate:modelValue": [
                    _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localDto.text_color) = $event)),
                    _ctx.emitModelChanged
                  ],
                  name: _ctx.$t('cms.eyebrowTextColor'),
                  label: _ctx.$t('cms.eyebrowTextColor'),
                  errors: _ctx.errors,
                  isBackground: false,
                  class: "mb-3"
                }, null, 8, ["modelValue", "name", "label", "errors", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title", "enabled", "name", "errors", "onUpdate:enabled", "onReset"])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}